import axios from 'axios';
import * as constants from '../constants/CONSTANT';
import { crmAuthHeaders } from './DataApi';

const baseUrl = `${constants.API_BASE_URL}/api/custom-scripts`;

/**
 * Load one active custom script by UUID or script_key (no source_code in response).
 * @param {string} identifier
 */
export async function getCustomScriptByIdOrKey(identifier) {
  const id = String(identifier ?? '').trim();
  if (!id) {
    return { success: false, message: 'Script id or key is required.' };
  }
  const res = await axios.get(`${baseUrl}/${encodeURIComponent(id)}`, {
    headers: { ...crmAuthHeaders() },
  });
  const body = res.data;
  if (!body || typeof body !== 'object') {
    return { success: false, message: 'Invalid response.' };
  }
  // API shape: { success, data: scriptRow }. Some proxies double-wrap `data`.
  let row = body.data;
  const looksLikeScript = (o) =>
    o &&
    typeof o === 'object' &&
    !Array.isArray(o) &&
    (o.script_key != null || o.id != null);
  if (!looksLikeScript(row) && row?.success === true && looksLikeScript(row?.data)) {
    row = row.data;
  }
  return { ...body, data: row };
}

/**
 * Run VM script by script_key or customScriptId (dynamic form submit, etc.).
 * @param {{ scriptKey?: string, customScriptId?: string, recordId: string, objectName: string, inputData?: object }} params
 */
export async function runCustomScriptPayload({
  scriptKey,
  customScriptId,
  recordId,
  objectName,
  inputData,
}) {
  const body = {
    recordId,
    objectName,
    inputData: inputData && typeof inputData === 'object' && !Array.isArray(inputData) ? inputData : {},
  };
  if (scriptKey != null && String(scriptKey).trim() !== '') {
    body.scriptKey = String(scriptKey).trim();
  }
  if (customScriptId != null && String(customScriptId).trim() !== '') {
    body.customScriptId = String(customScriptId).trim();
  }
  const res = await axios.post(`${baseUrl}/run`, body, {
    headers: { ...crmAuthHeaders(), 'Content-Type': 'application/json' },
  });
  return res.data;
}
